import BlogGridInner from "../components/BlogGridInner";
import Breadcrumb from "../components/Breadcrumb";
import CertificateOne from "../components/CertificateOne";
import FooterOne from "../components/FooterOne";
import HeaderOne from "../components/HeaderOne";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const BlogPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Blog Grid"} />

      {/* BlogGridInner */}
      <BlogGridInner />

      {/* CertificateOne */}
      <CertificateOne />

      {/* FooterOne */}
      
    </>
  );
};

export default BlogPage;
